import React, { useEffect, useState } from 'react';
import NavBar from '../../component/b2c/navBar/navBar';
import Sidebar from '../../component/b2c/sidebar/sidebar';
import { useMyContext } from '../../context/MyContext';
import '../../css/custom-scrollbar.css';
import { FaUser } from "react-icons/fa";
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import { Button } from '@mui/material';
import { IoMdEye } from 'react-icons/io';
import { MdDelete } from 'react-icons/md';
import axios from 'axios';
import Swal from "sweetalert2";
import { Base_Url, userlist,deleteuser } from '../../config/config';
import { toast } from 'react-toastify';
import '../../../src/css/custom-scrollbar.css'
import { CiEdit } from "react-icons/ci";
import { AiOutlineDownload } from "react-icons/ai";
import { Search } from 'lucide-react';
import ViewAllCustomerModel from '../../component/b2c/models/ViewAllCustomerModel';

const ViewAllCustomer = () => {
  const { isDarkMode, isToggleSidebar } = useMyContext();
  const [customers, setCustomers] = useState([]);
  const [totalCustomer, setTotalCustomers] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');


  useEffect(() => {
    fetchCustomers();
  }, [currentPage, limit]);

  const handleViewClick = (customer) => {
    setSelectedCustomer(customer);
    setIsPopupOpen(true);
  };

  const handleClose = () => {
    setIsPopupOpen(false);
  };

  const handleDownloadCSV = (customer) => {
    const csvContent = `data:text/csv;charset=utf-8,${[
      ["ID", "Name", "Email", "Phone", "Company Name", "Company Type", "GST No", "Pancard No", "Aadharcard No"],
      [customer.id,
      customer.name,
      customer.email,
      customer.phone,
      customer.company_name,
      customer.company_type,
      customer.gst_number,
      customer.pancard_number,
      customer.aadhar_number
      ]
    ]
      .map((row) => row.join(","))
      .join("\n")}`;
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `customer_${customer.id}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadAllCustomers = () => {
    const csvContent = [
      ["ID", "Name", "Email", "Phone", "Company Name", "Company Type", "GST No", "Pancard No", "Aadharcard No"],
      ...customers.map(customer => [
        customer.id,
        customer.name,
        customer.email,
        customer.phone,
        customer.company_name,
        customer.company_type,
        customer.gst_number,
        customer.pancard_number,
        customer.aadhar_number
      ])
    ]
      .map(row => row.join(","))
      .join("\n");

    if (customers.length === 0) {
      toast.error("No customers available to download");
      return;
    }

    const encodedUri = encodeURI(`data:text/csv;charset=utf-8,${csvContent}`);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "all_customers.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const fetchCustomers = async () => {
    const url = `${Base_Url}admin/${userlist}?page=${currentPage}&limit=${limit}`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.status === "SUCCESS") {
        const filteredCustomers = data.data.filter(customer => customer.role !== 'admin');
        const adminCount = data.data.filter(customer => customer.role === 'admin').length;
        const adjustedTotal = data.pagination.totalItems - adminCount;

        setCustomers(filteredCustomers);
        setTotalCustomers(adjustedTotal || 0);
      } else {
        toast.error(`Error: ${data.message} (Code: ${data.code})`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const getFilteredCustomers = () => {
    if (!searchTerm.trim()) {
      return customers;
    }

    const term = searchTerm.toLowerCase();
    return customers.filter(customer => {
      return (
        // Make sure to handle potential undefined values with optional chaining
        (customer.id?.toString().toLowerCase().includes(term)) ||
        (customer.name?.toLowerCase().includes(term)) ||
        (customer.phone?.toString().toLowerCase().includes(term))
      );
    });
  };

  const displayCustomers = getFilteredCustomers();

  const handleLimitChange = (e) => {
    setLimit(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const handlePaginationChange = (e, value) => {
    setCurrentPage(value);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows([...Array(customers.length).keys()]);
    } else {
      setSelectedRows([]);
    }
    setSelectAll(e.target.checked);
  };

  const handleRowSelect = (index) => {
    setSelectedRows((prev) => {
      const isSelected = prev.includes(index);
      if (isSelected) {
        return prev.filter(i => i !== index);
      } else {
        return [...prev, index];
      }
    });
  };



  const handleDelete = async (id) => {
    // Show SweetAlert confirmation dialog
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this deletion!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      // Only proceed with deletion if user confirms
      if (result.isConfirmed) {
        const urldelete = Base_Url + deleteuser;
        try {
          const token = localStorage.getItem('token');
          const cusid = localStorage.getItem('cus_id');
          const data = {
            retailer_id: id
          };
          const response = await axios.post(urldelete, data, {
            headers: {
              token,
              cus_id: cusid,
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
          });

          if (response.data.status === "SUCCESS") {
            fetchCustomers();
            Swal.fire(
              'Deleted!',
              response.data.message || 'Reatiler has been deleted successfully.',
              'success'
            );
          } else {
            // Show error message using SweetAlert
            Swal.fire(
              'Error!',
              'Unexpected response format: ' + response.data.message,
              'error'
            );
          }
        } catch (error) {
          // Show error message using SweetAlert
          Swal.fire(
            'Error!',
            'Error deleting Retailer: ' + error.message,
            'error'
          );
        }
      }
    });
  };


  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
      <div className="z-10">
        <NavBar />
      </div>

      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div
            className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
            style={
              window.innerWidth < 768
                ? { top: '113px', height: 'calc(100vh - 115px)', overflowY: 'auto' }
                : {}
            }
          >
            <Sidebar />
          </div>
        )}

        <div className="w-full dark:bg-darkmodeColor dark:text-white  dark:shadow-none rounded-custom p-4 md:ml-4  md:mb-8 custom-scrollbar overflow-x-hidden overflow-y-auto">
          <div className={`shadow-custom-light mb-6 mr-6 w-full rounded-custom dark:shadow-custom-dark p-4 ${isDarkMode ? 'dark:bg-darkmodeColor text-white' : ''}`}>
            <div className="flex flex-col sm:flex-row justify-between items-center">
              <button
                className="text-xl w-full sm:text-2xl font-bold mb-4 sm:mb-6 bg-customPurple hover:bg-purple-700 text-white font-sans px-2 sm:px-4 py-2 sm:py-1 rounded h-[40px]  sm:w-full flex items-center justify-center">
                <FaUser className="mr-2" size={24} />
                All Customers
              </button>
              {selectAll && (

                <div className='w-full sm:w-auto'>
                  <button
                    onClick={handleDownloadAllCustomers}
                    className="mb-4 sm:mb-6 w-full sm:ml-2 bg-green-500 h-[40px] hover:bg-green-600 text-white px-4 py-4 sm:px-8 sm:py-3 rounded flex items-center whitespace-nowrap"
                  >
                    <AiOutlineDownload className="mr-2" size={24} />
                    Download In Bulk
                  </button>
                </div>

              )}
            </div>
            <div className="relative
                  w-full ">
              <input
                type="text"
                value={searchTerm}
                onChange={handleSearchChange}
                placeholder="Search by Name/Id/Phone.."
                className="w-full px-4 py-2 pr-10 rounded-lg border border-gray-300 dark:border-gray-700 
                            bg-white dark:bg-darkmodeColor text-gray-900 dark:text-white
                            focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <Search className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
            </div>
            <div className='overflow-x-auto mt-6 rounded-xl'>
              <table className="min-w-full w-full table-auto">
                <thead className="bg-customPurple text-white text-[14px]">
                  <tr className='bg-customPurple text-white border border-[#aba7a7]'>
                    <th className='p-2 text-left'>
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                    </th>
                    <th className="p-2 text-left w-1/12">ID</th>
                    <th className="p-2 text-left w-2/12">Name</th>
                    <th className="p-2 text-left w-3/12">Email</th>
                    <th className="p-2 text-left w-2/12">Phone</th>
                    <th className="p-2 text-left w-2/12 pl-12">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {displayCustomers.map((customer, index) => (
                    <tr key={customer.id} className="w-full">
                      <td className='p-2'>
                        <input
                          type="checkbox"
                          checked={selectedRows.includes(index)}
                          onChange={() => handleRowSelect(index)}
                        />
                      </td>
                      <td className="p-2">{customer.id}</td>
                      <td className="p-2">{customer.name}</td>
                      <td className="p-2">{customer.email}</td>
                      <td className="p-2">{customer.phone}</td>
                      <td className="p-2">
                        <div className="flex space-x-2">
                          <Button variant="contained" size="small" color="primary"
                            onClick={() => handleViewClick(customer)}
                          >
                            <IoMdEye />
                          </Button>
                          <Button variant="contained" size="small" color="error"  onClick={() => handleDelete(customer.id)}>
                            <MdDelete />
                          </Button>
                          <Button variant="contained" size="small" color="secondary"
                            onClick={() => handleDownloadCSV(customer)}>
                            <AiOutlineDownload />
                          </Button>
                          {/* <Button variant="contained" size="small" color="primary">
                              <CiEdit/>
                            </Button> */}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="mt-4 flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
            <span className="text-sm text-gray-700 font-bold dark:text-gray-300">{`Total customer: ${totalCustomer}`}</span>
            <select
              id="limit"
              value={limit}
              onChange={handleLimitChange}
              className="border rounded p-1 sm:ml-[480px] text-sm bg-white dark:bg-darkmodeColor dark:text-gray-200"
            >
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
              <option value={25}>25</option>
              <option value={30}>30</option>
              <option value={totalCustomer}>All</option>
            </select>
            <Pagination
              count={Math.ceil(totalCustomer / limit)}
              page={currentPage}
              onChange={handlePaginationChange}
              variant="outlined"
              shape="rounded"
              className="pagination"
              size="small"
              renderItem={(item) => (
                <PaginationItem
                  {...item}
                  className={`mx-1 rounded-md ${item.selected ? 'bg-customPurple text-white' : 'text-gray-700 dark:text-gray-300'} hover:bg-purple-700 hover:text-white`}
                />
              )}
            />
          </div>
        </div>
        <ViewAllCustomerModel isopen={isPopupOpen} onClose={handleClose} customer={selectedCustomer} />
      </div>
    </div>
  );
};

export default ViewAllCustomer;